import Event from './Event.js'
import Price from './Price'

class Trade extends Event {
  constructor(rec){
    super(rec)
    this._pricing = new Price({})
    this._intacc_pricing = new Price({})
  }
  get trade_costs_ids(){
    return this.constructor.employeeStore.event_relations.filter(rel => (rel.parent_id === this.id)&&(rel.child_type === 'TradeCost')).map(rel => rel.child_id)
  }
  get trade_costs(){
    let ids = this.trade_costs_ids
    if(ids.length === 0){return []}
    return this.constructor.employeeStore.events.filter(ev => ids.includes(ev.id))
  }
  get costs_aep(){
    var value = 0
    this.trade_costs.forEach((tc) => {
      if(tc.account_id===this.account_id){
        value -= tc.value_aep
      } else {
        value -= tc.computeLocale(tc.value_aep (this.account||{crncy: 'DKK'}).crncy)
      }
    })
    return value
  }
  get costs_aep_pct(){
    return this.costs_aep / this.clean_value
  }
  get costs_sf(){
    var value = 0
    this.trade_costs.forEach((tc) => {
      if(tc.account_id===this.account_id){
        value -= tc.value_sf
      } else {
        value -= tc.computeLocale(tc.value_sf (this.account||{crncy: 'DKK'}).crncy)
      }
    })
    return value
  }
  get costs_sf_pct(){
    return this.costs_sf / this.clean_value
  }
  get costs_pct(){
    return this.costs / this.clean_value
  }
  get total_costs(){
    return this.costs + this.costs_sf + this.costs_aep
  }
  get total_costs_pct(){
    return this.total_costs / this.clean_value
  }
  get total_value(){
    return -(this.clean_value + this.intacc + this.total_costs)
  }
  fetchMarketData(){
    if(this.sdate && this.issue_id){
      if(this._market_data_date && (JSON.stringify([this.issue_id, this.sdate])===JSON.stringify(this._market_data_date))){
        return new Promise((resolve,reject)=>{resolve;reject})
      } else {
        this.fetchCurrencyRate()
        if(this.trade_costs_ids.length>0){
          this.trade_costs.forEach(tc => tc.fetchCurrencyRate())
        }
        return this.constructor.employeeStore.controllers.PricesController.getPrice(this.issue_id, this.sdate).then((res)=>{
          this._pricing = res
          if(this.issue.bond){
            return this.constructor.employeeStore.controllers.PricesController.getIntacc(this.issue_id, this.sdate).then((res)=>{
              this._intacc_pricing = res
              this._market_data_date = [this.issue_id, this.sdate]
            })
          } else {
            this._market_data_date = [this.issue_id, this.sdate]
            return true
          }
        })
      }
    }
  }
  get costs_default(){
    return 0
  }
  get price_default(){
    return parseFloat(this._pricing.price)
  }
  get crncyrate_default(){
    if(this.issue && this.account){
      return this._currency_rate.getRate(this.issue.crncy, this.account.crncy)
    } else {
      return 1
    }
  }
  get intacc_rate(){
    if(this.issue && this.issue.bond){
      return parseFloat(this._intacc_pricing.intacc)
    } else {
      return 0
    }
  }
  get intacc_default(){
    return Math.round(this.intacc_rate * Math.abs(this.amount||1) * (this.crncyrate||this.crncyrate_default))/100
  }
  get scalar(){
    if(this.issue && this.issue.bond){
      return 100
    } else {
      return 1
    }
  }
  get clean_value(){
    return Math.abs(this.price*this.crncyrate*this.amount / this.scalar)
  }
  get solved_value(){
    return -Math.round((this.price * this.amount / this.scalar * this.crncyrate + Math.sign(this.amount) * this.intacc + this.costs)*100)/100
  }
  get solved_crncyrate(){
    return this.scalar * (-this.value - this.costs-Math.sign(this.amount)*this.intacc) / (this.amount * this.price)
  }
  get solved_price(){
    return this.scalar * (-this.value - this.costs - Math.sign(this.amount) * this.intacc ) / ( this.amount * this.crncyrate )
  }
  get solved_costs(){
    return -this.value - Math.sign(this.amount) * this.intacc - this.amount / this.scalar * this.price * this.crncyrate
  }
  get solved_amount(){
    return -this.scalar * (this.value - Math.sign(this.value) * this.intacc + this.costs)/(this.price*this.crncyrate)
  }
  get solved_intacc(){
    return Math.round(((this.value + this.price * this.amount / this.scalar * this.crncyrate + this.costs) / (-Math.sign(this.amount)))*100)/100
  }
  get trades(){
    return this.constructor.employeeStore.events.filter((ev) => {
      return ((ev.type==='Trade')||(ev.type==='IncomeTrade'))&&
             (ev.deposit_id === this.deposit_id)&&
             (ev.issue_id===this.issue_id)&&
             (ev.sdate<=this.sdate)
    })
  }
  get holding(){
    return this.trades.reduce((sum,tr)=> sum+(tr.amount||0),0)
  }

  get trade_cancel(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='TradeCancel'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get trade_expected(){
    return (this.trade_cancel||{}).trade_expected
  }

  get linked(){
    return this.trade_cancel != null
  }

  // 1. If the trade has manual_value => then it doesn't need a status text
  // 2. If the traded issue has the require_trade_expected field set to true => then it needs a status text
  get should_be_linked() {
    return this.manual_value !== true && this.issue?.require_trade_expected
  }
}

export default Trade
